import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { AppConstants } from '../../app.constants';
import { IAppSettings } from '../../models/app-settings.model';
import { LayoutModule } from "@progress/kendo-angular-layout";
import { TccSingleSelectFieldComponent } from "../../shared/components/tcc-single-select-field/tcc-single-select-field.component";
import { FormControl } from '@angular/forms';
import { PageChangeEvent, GridModule, GridDataResult } from "@progress/kendo-angular-grid";
import { GetDashboardNotesRequest } from '../../models/dashboard-notes/GetDashboardNotesReuestDto.model';
import { DashboardService } from '../../services/dashboard.service';
import { CommonModule } from '@angular/common';
import { process } from '@progress/kendo-data-query';
import { SpinnerService } from '../../services/spinner.service';
import { PaginationResponseBase } from '../../models/pagination-response-base';
import { ActivatedRoute } from '@angular/router';
import { JobInputParamsDto } from '../../models/JobInputParamsDto.model';
import { TeamsService } from '../../services/teams.service';
import { TeamsDto } from '../../models/TeamsDto.model';
import { HoursAgoPipe } from '../../shared/pipes/hours-ago.pipe';
import { AppUtilityService } from '../../services/appUtilityService.service';

@Component({
  selector: 'app-dashboard-note',
  standalone: true,
  imports: [LayoutModule, TccSingleSelectFieldComponent, GridModule, CommonModule,HoursAgoPipe],
  templateUrl: './dashboard-note.component.html',
  styleUrl: './dashboard-note.component.css',
    encapsulation: ViewEncapsulation.None,
})
export class DashboardNoteComponent implements OnInit {  
  public appConstants: typeof AppConstants = AppConstants;

  private appSettings: IAppSettings = (<any>window)[AppConstants.AppSettings];
    @ViewChild('dialogContainer', { read: ViewContainerRef }) dialogContainer: ViewContainerRef = {} as ViewContainerRef;
    public request: GetDashboardNotesRequest = new GetDashboardNotesRequest();

  public functionalRole:TeamsDto[] = [];
  public dashboardNotesData: GridDataResult = process([], {});
  public showNoRecordMesage!:boolean;
  public readonly functionalRoleController: FormControl = new FormControl(null);
  public teamId!:number;
public dashboardNoteColumns: any[] = [
    {
      field: 'jobID',
      sortable: false,
      width: 500,
      class:"",
      headerClass: 'action-column',
    }
  ]

  public inputData: JobInputParamsDto = new JobInputParamsDto();
  constructor(public dashboardService:DashboardService,
    private spinnerService:SpinnerService,
        private route: ActivatedRoute,
        private teamsService: TeamsService,
            private cdr: ChangeDetectorRef,
            private appUtilityService: AppUtilityService
  ){}

  public ngOnInit(): void {
    this.getTeamsDataList();
    this.route.queryParams.subscribe((params: any) => {
      this.inputData = params;
      this.request.skip = this.dashboardService.pageChangeInfo.skip;
      this.request.pageSize = this.dashboardService.pageChangeInfo.take;
      this.request.teamId = +this.inputData.teamId;
      this.functionalRoleController.setValue(+this.inputData.teamId)
    });
    this.request.pageSize = 5;
    this.GetDashboardNotelist();
  }
  
  public getTeamsDataList(){
    this.spinnerService.isLoading.next(true);
    const url = `${this.appSettings.coreApiPath}${this.appConstants.TeamsEndPoint}`;
    this.teamsService.getListOfTeamsData(url).subscribe({
      next:(data:TeamsDto[])=>{
        if(data != null){
          this.functionalRole = data
          this.spinnerService.isLoading.next(false);  
        }
      },
      error: (error) => {
          console.log(error);
          this.spinnerService.isLoading.next(false);
      },
    })
  }
  
  public onPageChange(event: PageChangeEvent): void {
    this.request.pageSize = event.take;
    this.request.skip = event.skip;
    this.dashboardService.pageChangeInfo = { skip: event.skip, take: event.take };
    this.GetDashboardNotelist();
  }
  private GetDashboardNotelist(){
    this.spinnerService.isLoading.next(true);
    const url = `${this.appSettings.coreApiPath}${this.appConstants.NotesEndPoint}`;
    this.dashboardService.getDashboardNotesData(url,this.request).subscribe({
      next:(response:PaginationResponseBase)=>{
        if(response != null){
          this.showNoRecordMesage = response.data.length == 0;
          this.dashboardNotesData.data = response.data
          this.dashboardNotesData.total = response.totalRecords;
          this.cdr.detectChanges();
          this.spinnerService.isLoading.next(false); 
        }
      },
      error: (error) => {
          this.appUtilityService.onAlertDialog(
          this.dialogContainer,
          AppConstants.TCCImportantNotesLabel,
          error,
          this.appConstants.OkButtonLabel,
          this.appConstants.AlertReponseDialogWidth
        );
          console.log(error);
          this.spinnerService.isLoading.next(false);
          this.dashboardNotesData.data = [];
          this.showNoRecordMesage = true;
      },
    })
  }
  public functionalRoleChange(){
      this.request.skip = this.dashboardService.pageChangeInfo.skip;
      this.request.pageSize = this.dashboardService.pageChangeInfo.take;
      this.request.teamId = this.functionalRoleController.value;
      this.GetDashboardNotelist();
  }
}
